import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';

@Component({
  selector: 'micro-os-type-detail',
  templateUrl: './os-type-detail.component.html',
})
export class OsTypeDetailComponent implements OnInit, OnDestroy {
  @Input() osTypeId: any;
  @Output() persisted = new EventEmitter<any>();
  osType: any;
  private routeSubscription?: Subscription;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient,
              private route: ActivatedRoute, private router: Router, private alertService: AlertService) {}

  ngOnInit(): void {
    if (this.osTypeId) {
      this.load(this.osTypeId);
    } else {
      this.routeSubscription = this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/cmdbOsType/${id}`).subscribe(data => {
      this.osType = data;
    });
  }

  createNew(): void {
    this.osType = { code: '', name: '', description: 'None', active: 'N', companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const isUpdate = !!this.osType.id;
    const params = new HttpParams().set('companyId', this.osType.companyId);
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/cmdbOsType/${this.osType.id}`, this.osType, {params})
      : this.http.post(`${this.env.e.url}/domain/cmdbOsType`, this.osType, {params});
    request.subscribe(data => {
      this.osType = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.osType.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/cmdbOsType/${this.osType.id}`).subscribe(() => {
      this.persisted.emit({data: this.osType, action: 'deleted'});
      this.alertService.info(`Deleted ${this.osType.name}`);
      if (!this.osTypeId) { this.router.navigate(['/osType']); }
    });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.osType.active = target.checked ? 'Y' : 'N';
  }
}
